import serverInterface from 'server-interface';

import externalEventCodes from 'event-system/codes/external';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

class PromotionCodesManager {

  constructor(application) {

    this.initialized = false;
    this.collection = [];

    this.application = application;

  }

  async initialize(bootstrapData) {

    this.registerEventHandlers();

    this.collection = bootstrapData.promotionCodes;

    this.initialized = true;

  }

  tryAdd(item) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', item._id);

    if (itemIndex !== -1) {
      return;
    }

    this.collection.push(item);

  }

  tryRemove(itemId) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', itemId);

    if (itemIndex === -1) {
      return;
    }

    this.collection.splice(itemIndex, 1);

  }

  handleCreatedEvent(payload) {

    this.tryAdd(payload.promotionCode);

  }

  handleDeletedEvent(payload) {

    this.tryRemove(payload.promotionCode._id);

  }

  registerEventHandlers() {

    this.application.eventSystem.internal.on(externalEventCodes.PROMOTION_CODE_CREATED, this.handleCreatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.PROMOTION_CODE_DELETED, this.handleDeletedEvent.bind(this));

  }

  async loadAll() {

    this.collection = await serverInterface.startup.promotionCodes.getPromotionCodesByQueryOptions();

  }

  getAll() {

    return structuredClone(this.collection);

  }

  isExistsById(itemId) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', itemId);

    return itemIndex !== -1;

  }

  async create(payload) {

    let item = null;

    if (typeof payload.amount_off === 'number') {
      item = await serverInterface.startup.promotionCodes.createAmountOffPromotionCode(payload);
    } else {
      item = await serverInterface.startup.promotionCodes.createPercentOffPromotionCode(payload);
    }

    this.tryAdd(item);

    return item;

  }

  async delete(itemId) {

    await serverInterface.startup.promotionCodes.deletePromotionCode(itemId);

    this.tryRemove(itemId);

  }

}

export default PromotionCodesManager;